import { signal } from "../net/signal";

/**
 * چتِ میز — عبارت‌های آماده و تنظیم‌هایی که در همین مرورگر می‌مانند.
 *
 * دو کنترل این‌جاست و هیچ‌کدام به سرور نمی‌رود: بی‌صدا کردنِ یک نفر، و خاموش
 * کردنِ کلِ چت. هر دو تصمیمِ شخصی‌اند و سرور نه باید بداند چه کسی را دوست
 * نداری، نه باید پیامی را به‌خاطرِ سلیقه‌ی یک نفر پخش نکند.
 */

/** آینه‌ی chat.Canned سمتِ سرور — کلید باید دقیقاً همان باشد. */
export const cannedPhrases = [
  { key: "salam", fa: "سلام!" },
  { key: "bravo", fa: "آفرین!" },
  { key: "nice_move", fa: "چه حرکتی!" },
  { key: "clap", fa: "👏" },
  { key: "unbeliev", fa: "باورم نمی‌شه!" },
  { key: "lucky", fa: "شانس آوردی" },
  { key: "oops", fa: "ای وای…" },
  { key: "hurry", fa: "یالا دیگه!" },
  { key: "thanks", fa: "دمت گرم" },
  { key: "good_game", fa: "بازی خوبی بود" },
] as const;

/** واکنش‌های یک‌لمسی (مارپله) — کلیدهای chat.Canned ِ سرور، بیرونِ فهرستِ عبارت‌ها. */
export const reactionPhrases = [
  { key: "r_laugh", fa: "😂" },
  { key: "r_shock", fa: "😱" },
  { key: "clap", fa: "👏" },
  { key: "r_sad", fa: "😢" },
] as const;

/** رویدادِ پنجره‌ای که برگه‌ی چتِ میز (App) را باز و بسته می‌کند — دکمه‌های چتِ پایینِ میز. */
export const CHAT_TOGGLE = "bazivan:chat-toggle";

/**
 * چند پیامِ client.chat را برگه‌ی چت دیده است. «نخوانده» یعنی بقیه — همان عددِ رویِ دکمه‌ی چت.
 * یک جا، چون دکمه دیگر یکی نیست: ردیفِ پایینِ منچ و دومینو، و دکمه‌ی گردِ میزهای دیگر.
 */
export const chatSeen = signal(0);

/** متنِ یک عبارتِ آماده. کلیدِ ناشناخته (کلاینتِ تازه‌تر) خودش نشان داده می‌شود. */
export function cannedText(key: string): string {
  return cannedPhrases.find((p) => p.key === key)?.fa ?? reactionPhrases.find((p) => p.key === key)?.fa ?? key;
}

const MUTED_KEY = "bazivan.chat.muted";
const OFF_KEY = "bazivan.chat.off";

/** شناسه‌ی کسانی که برای من بی‌صدا شده‌اند. */
export const muted = signal<ReadonlySet<string>>(load());

/** چت را کلاً خاموش کرده‌ام؟ */
export const chatOff = signal(loadOff());

export function isMuted(playerId: string): boolean {
  return muted.value.has(playerId);
}

export function toggleMute(playerId: string): void {
  if (!playerId) return;
  const next = new Set(muted.value);
  if (!next.delete(playerId)) next.add(playerId);
  muted.value = next;
  save(MUTED_KEY, JSON.stringify([...next]));
}

export function setChatOff(off: boolean): void {
  chatOff.value = off;
  save(OFF_KEY, off ? "1" : "");
}

function load(): Set<string> {
  try {
    const raw = localStorage.getItem(MUTED_KEY);
    return new Set(raw ? (JSON.parse(raw) as string[]) : []);
  } catch {
    return new Set(); // حالتِ ناشناس، یا ذخیره‌ی خراب
  }
}

function loadOff(): boolean {
  try {
    return localStorage.getItem(OFF_KEY) === "1";
  } catch {
    return false;
  }
}

function save(key: string, value: string): void {
  try {
    if (value) localStorage.setItem(key, value);
    else localStorage.removeItem(key);
  } catch { /* حالتِ ناشناس — تنظیم فقط تا بستنِ صفحه می‌مانَد */ }
}
